import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton, Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { put } from "../../utils/api";
import InputField from "../../Components/Masters/InputField";
import SelectField from "../../Components/Masters/SelectField";
import FileField from "../../Components/Masters/FileField";
import Multiline from "../../Components/Masters/Multiline";
import DocumentItem from "../../Components/Masters/DocumentItem";

function ResolvedTicket({
  inputData,
  fetchData,
  id,
  data,
  isDrawerOpen,
  setIsDrawerOpen,
  setsnackOpen,
  ViewData,
  fetchCardData,
}) {
  console.log("first1", inputData, ViewData);
  const [errors, setErrors] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (ViewData) {
      setFormData({
        ...ViewData,
        // resolvedRemark: "",
      });
    }
  }, [ViewData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
    setErrors({});
    setUploadedFiles([]);
    setUploadProgress({});
  };

  const validateForm = () => {
    const newErrors = {};
    const excludedFields = ["documents"]; // Fields to exclude
    if (formData.raisedAgainst === "SuperAdmin") {
      excludedFields.push("assignedTo");
    }
    inputData.forEach((input) => {
      // Skip validation for excluded fields
      if (excludedFields.includes(input.fieldName)) return;
      console.log("first23", input.fieldName, excludedFields);
      const value = formData[input.fieldName];

      // Check if the field value is empty or invalid
      if (!value || String(value).trim() === "") {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
    });

    setErrors(newErrors);

    // Return true if there are no new errors
    return Object.keys(newErrors).length === 0;
  };

  console.log("first231", formData, errors);

  const Save = async () => {
    if (!validateForm()) return;
    let formDataToSend = { ...formData, resolvedDocuments: uploadedFiles };

    await put(`/support/ticket/update?Id=${ViewData?._id}`, formDataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        fetchCardData();
        handleClose();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.type === "select")
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.option}
          url={el.url}
          errors={errors[el.fieldName]}
        />
      );

    if (el.type === "file") {
      return (
        <FileField
          title={el.title}
          name={el.fieldName}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
        />
      );
    }
    if (el.type === "multiline")
      return (
        <Multiline
          title={el.title}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          fieldName={el.fieldName}
          errors={errors[el.fieldName]}
        />
      );
    else if (el.type === "text") {
      return (
        <InputField
          title={el.title}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    }
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "400px" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "90%", p: 3, backgroundColor: "#fff", height: "100%" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Ticket " : "Resolve Ticket"}
        </Typography>
        <Typography sx={{ fontWeight: "bold", mt: 2 }}>Ticket ID</Typography>
        <p>{ViewData?.ticketNumber}</p>
        <Typography sx={{ fontWeight: "bold", mt: 2 }}>Created Date</Typography>
        {new Date(ViewData?.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }) ?? ""}
        <Typography sx={{ fontWeight: "bold", mt: 2 }}>Title</Typography>
        <p>{ViewData?.title}</p>
        <Typography sx={{ fontWeight: "bold", mt: 2 }}>Description</Typography>
        <p>{ViewData?.description}</p>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Uploaded Documents
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {ViewData?.documents && ViewData?.documents?.length > 0 ? (
              <>
                {" "}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {ViewData.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {ViewData.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              </>
            ) : (
              <Typography>-</Typography>
            )}
          </Box>
        </Box>
        {inputData.map((el) => (
          <div key={el.fieldName}>{renderInputField(el)}</div>
        ))}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={isDrawerOpen}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default ResolvedTicket;
